import "../../styles/pageskelton.css";

/**
 * SkeletonBox — reusable shimmer block
 * Props:
 *   className  — extra class (from pageskelton.css)
 *   style      — inline override (width, height, etc.)
 *   rounded    — "full" for circle (avatar), "pill" for pill shape
 */
const SkeletonBox = ({ className = "", style = {}, rounded }) => {
  const extra =
    rounded === "full"
      ? { borderRadius: "50%" }
      : rounded === "pill"
      ? { borderRadius: "20px" }
      : {};

  return <div className={`sk-box ${className}`} style={{ ...extra, ...style }} />;
};

export default SkeletonBox;
